<template>
  <div class="table-action-wrapper scan-and-print-tracking" ref="container">
    <span class="item-selected mb-0" v-html="`Selected: ${Object.keys(ids).length} ${Object.keys(ids).length > 1 ? 'items' : 'item'}`"></span>&nbsp;
    <a class="mb-2 mr-2 btn-transition btn btn-outline-primary" href="#" @click.prevent="handlePrint()">Print Now</a>
  </div>
</template>

<script>
import print from '@/helper/print.js'
export default {
  data() {
    return {
      ids: []
    }
  },
  mounted() {
    this.store.commit('cols.cb.hidden', false)
  },
  unmounted() {
    this.store.commit('cols.cb.hidden', true)
  },
  computed: {
    store() {
      return this.config?.store
    },
    cb() {
      return this.config?.cb
    }
  },
  methods: {
    handlePrint() {
      let orders = []
      Object.entries(this.store.getter('rows', {})).forEach(([, row]) => {
        if (this.ids.includes(row._id)) {
          let order = _.cloneDeep(row.information || {})
          order.id = row._id
          order.line_items = row.line_items
          orders.push(order)
        }
      })
      print.orders(orders, this.submitAfterPrint)
    },
    submitAfterPrint() {
      let ids = []
      Object.entries(this.store.getter('rows', {})).forEach(([, row]) => {
        if (this.ids.includes(row._id)) ids.push(row._id)
      })

      this.$util.post(
        '/order/more/update-after-print',
        {
          ids
        },
        this.$refs.container
      )
    }
  },
  watch: {
    cb: {
      handler(values) {
        this.ids = []
        Object.entries(values).forEach(([id, checked]) => {
          if (checked) {
            this.ids.push(id)
          }
        })
      },
      deep: true
    }
  },
  props: {
    config: Object
  }
}
</script>
